import React from 'react';
import { PreviewPane } from './PreviewPane';
import css from './ContractWizardModal.module.css';

export interface ContractPreviewPaneProps {
  previewSrc: string | Blob | undefined;
  onRefresh: () => void;
  loadingPdfPreview: boolean;
}

export function ContractPreviewPane({
  previewSrc,
  onRefresh,
  loadingPdfPreview,
}: ContractPreviewPaneProps) {
  if (!previewSrc) return null;

  return (
    <>
      <h3 className={css.compensationHeading}>PDF Vorschau</h3>
      <div className={css.previewSection}>
        <PreviewPane
          src={previewSrc}
          onRefresh={onRefresh}
          loading={loadingPdfPreview}
          height={720}
        />
      </div>
    </>
  );
}
